module.exports = __webpack_public_path__ + "static/media/mail.951b0d69.svg";